import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORT_ACCESS_LEVEL_OPTIONS } from '../model/support-access.model.js';

function SupportAccessGrantModal({
  isSaving,
  form,
  formErrors,
  onFormChange,
  onSubmit,
  onClose,
  accessLevelOptions = SUPPORT_ACCESS_LEVEL_OPTIONS,
}) {
  const { t } = useTranslation();

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t('systemUsers.supportGrantTitle')}</h5>
              <button type="button" className="btn-close" onClick={onClose} disabled={isSaving}></button>
            </div>
            <form onSubmit={onSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">{t('systemUsers.supportLabelLabel')}</label>
                  <input
                    className={`form-control ${formErrors.label ? 'is-invalid' : ''}`}
                    value={form.label}
                    onChange={(event) => onFormChange('label', event.target.value)}
                    required
                  />
                  {formErrors.label ? <div className="invalid-feedback">{formErrors.label}</div> : null}
                </div>

                <div className="mb-3">
                  <label className="form-label">{t('systemUsers.supportAccessLevelLabel')}</label>
                  <select
                    className={`form-select ${formErrors.accessLevel ? 'is-invalid' : ''}`}
                    value={form.accessLevel}
                    onChange={(event) => onFormChange('accessLevel', event.target.value)}
                    required
                  >
                    {accessLevelOptions.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                  {formErrors.accessLevel ? <div className="invalid-feedback">{formErrors.accessLevel}</div> : null}
                </div>

                <div className="mb-3">
                  <label className="form-label">{t('systemUsers.supportExpiresAtLabel')}</label>
                  <input
                    type="datetime-local"
                    className={`form-control ${formErrors.expiresAt ? 'is-invalid' : ''}`}
                    value={form.expiresAt}
                    onChange={(event) => onFormChange('expiresAt', event.target.value)}
                    required
                  />
                  {formErrors.expiresAt ? <div className="invalid-feedback">{formErrors.expiresAt}</div> : null}
                </div>

                <div>
                  <label className="form-label">{t('systemUsers.supportReasonLabel')}</label>
                  <textarea
                    className={`form-control ${formErrors.reason ? 'is-invalid' : ''}`}
                    rows="3"
                    value={form.reason}
                    onChange={(event) => onFormChange('reason', event.target.value)}
                    required
                  ></textarea>
                  {formErrors.reason ? <div className="invalid-feedback">{formErrors.reason}</div> : null}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={onClose} disabled={isSaving}>{t('common.cancel')}</button>
                <button type="submit" className="btn btn-theme" disabled={isSaving}>{t('systemUsers.supportGrantSubmit')}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default SupportAccessGrantModal;
